module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/init/init.html
// module id = ./src/app/pages/init/init.html
// module chunks = main